import React from "react";
import "./realtimeData.scss";
import AlertsAndNotifications from "./sections/alertsAndNotifications";
import ApisEWebhooks from "./sections/apisEWebhooks";
import DataPushAndPull from "./sections/dataPushAndPull";
import DataRefreshTriggers from "./sections/dataRefreshTriggers";
import SectionRealtime from "./sections/sectionRealtimeData";
import SendingLoading from "./sections/sendingLoading";
import WhatIs from "./sections/whatIs";
import Letsgo from "../connectors/letsgo"
import SafeInformation from "../connectors/safeInformation";

const RealtimeData = () => {
  return (
    <div className="container-realtime">
      <div className="section-realtime-data">
        <SectionRealtime />
      </div>
      <div className="section-what-is">
        <WhatIs />
      </div>
      <div className="section-apis-e-webhooks">
        <ApisEWebhooks />
      </div>
      <div className="section-data-refresh-triggers">
        <DataRefreshTriggers />
      </div>
      <div className="section-alerts-and-notifications">
        <AlertsAndNotifications />
      </div>
      <div className="section-data-push-and-pull">
        <DataPushAndPull />
      </div>
      <div className="section-sending-loading">
        <SendingLoading />
      </div>
      <div className="section-letsgo">
        <Letsgo />
      </div>
    </div>
  );
};
export default RealtimeData;
